import './theme.scss';
import '../../scripts/snippets/carousel.js';
import '../../scripts/snippets/product-tile.js';
import '../../scripts/snippets/recently-viewed.js';
import { initInputs } from '@components/inputs';
import { initAccordions } from '@components/accordions';
import { initModals } from '@components/modals';
import { initMinicart } from '@components/minicart';
import { initVideoControls } from '@components/media';
import { initFirstWishlit } from '@components/wishlist';
(() => {
  initInputs();
  initAccordions();
  initModals();
  initMinicart();
  initVideoControls();
  initFirstWishlit();
})();
